import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Push/click navigation -> scroll to top. Browser Back/Forward (POP) -> restore.
export const ScrollManager = () => {
  const location = useLocation();
  const navType = useNavigationType();
  const positions = useRef({});
  const lastKey = useRef("default");

  useEffect(() => {
    const save = () => {
      positions.current[lastKey.current] = window.scrollY;
    };
    window.addEventListener("scroll", save, { passive: true });
    return () => window.removeEventListener("scroll", save);
  }, []);

  useEffect(() => {
    if (navType === "POP" && positions.current[location.key] != null) {
      const y = positions.current[location.key];
      requestAnimationFrame(() => {
        if (window.lenis) window.lenis.scrollTo(y, { immediate: true });
        else window.scrollTo(0, y);
      });
    } else {
      if (window.lenis) window.lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }
    lastKey.current = location.key;
  }, [location.key, navType]);

  return null;
};
